import forge from 'node-forge'
import { saveAs } from 'file-saver/FileSaver';

//restful api
import { temp as wsfinder } from '@/service/api/wsfinder'

export default {
  data : () => {
    return {
      remove_confirm : false,
      regist_confirm : false,
      lock: true,
      decrypted : false,
      model : {},
      content : '',
    }
  },
  methods: {
    decrypt : function() {
      try {
        // 바이너리일 경우 강제 내용 보기
        let content = forge.util.decode64(this.model.data)
        try {
          this.content = forge.util.decodeUtf8(content) // 한글 처리
        } catch (error) { this.content = unescape(content) }

      } catch (e) { this.$toastr.e('decode failed', 'not support this format') }
      finally { this.decrypted = true }
    },
    download: function(){
      let blob = new Blob([this.model.data], {type: "text/plain;charset=utf-8"});
      saveAs(blob, this.model.name+'.F1');
    },
    async remove() {
      try{
        let rs = await wsfinder.deleteTemp({ id : this.model.id})
        if(!rs.error) {
          this.$toastr.s('delete.', this.$route.name);
        } else {
          this.$toastr.e('delete', "failed");
        }
        this.$emit('refresh'); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async add() {
      try{
        let rs = await wsfinder.registTemp({ id : this.model.id})
        if(!rs.error) {
          this.$toastr.s('add', this.$route.name);
        } else {
          this.$toastr.e('add', "failed");
        }
        this.$emit('refresh'); this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    list: function() { this.$router.push({ name: 'wsfinder_regist'}); },
    get: function(id = this.$route.params.id) {
      console.log('regist.detail.vue', 'load item', id);
      return wsfinder.detailTemp({id : id})
        .then(rs => {
          this.model = Object.assign({}, this.model, rs.body);

          if (this.model.is_binary){ console.log('is_binary'); }
          else {
            let data = forge.util.decode64(this.model.data, 'base64');
            this.model.data = forge.util.decodeUtf8(data)
          }
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); } },
  created: function() { console.log('regist.detail.vue', 'created'); },
  destroyed: function() { console.log('regist.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('regist.detail.vue', 'mounted');
    this.get(this.$route.params.id);
  },
}